import React, { Component } from 'react';
import { API } from 'aws-amplify';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DateInput from 'components/form/DateInput';
import Select from 'components/form/Select';
import Button from 'components/common/Button';

const styles = (theme) => ({
  root: {
    'minWidth': 360,
    'maxWidth': 600,
    'padding': theme.spacing(3),
    '& .search-bar': {
      marginBottom: theme.spacing(2),
    },
    '& h6': {
      marginBottom: 24,
    },
  },
  closeIcon: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  }
});

class AddSchool extends Component {
  state = {
    selected: null,
    due_date: null,
    location: null,
    loading: false
  };

   getCollegeInfo = async (collegeId) => {
    await API.get('api', `/college/${collegeId}`).then((data) => {
      this.setState({location: `${data['school.city']}, ${data['school.state']}`})
    });
  }

  onChange = async (val) => {
    await this.setState({ selected: val });
    await this.setState({ loading: true });
    await this.getCollegeInfo(val.value)
    await this.setState({ loading: false });
  };

  onDateChange = (date) => {
    this.setState({ due_date: date });
  };

  loadOptions = (query, loadedOptions, { page }) => {
    return API.get('api', '/college/search', {
      queryStringParameters: {
        name: query,
        fields: 'id,school.name',
        page,
        per_page: 10,
      },
    }).then((resp) => {
      let options = resp.results.map((i) => ({
        label: i['school.name'],
        value: i.id,
      }));
      return {
        options,
        hasMore: Math.ceil(resp.metadata.total / resp.metadata.per_page) > page,
        additional: {
          page: page + 1,
        },
      };
    });
  };

  onAdd = () => {
    const { selected, due_date, location } = this.state;
    this.setState({ loading: true });
    this.props
      .onAddSchool(this.props.category.type, selected, due_date, location)
      .then(() => this.props.onClose)
      .then(() => this.setState({ loading: false }))
  };
  render() {
    const { selected, due_date } = this.state;
    const { classes, onClose, category } = this.props;
    return (
      <div className={classes.root}>
        <Typography gutterBottom variant="subtitle1">
          Add University to {category.name}
        </Typography>
        <IconButton className={classes.closeIcon} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <div className="search-bar">
          <Select
            async
            paginate
            debounceTimeout={300}
            cacheOptions
            defaultOptions
            isMulti={false}
            loadOptions={this.loadOptions}
            onChange={this.onChange}
            additional={{
              page: 0,
            }}
            value={selected}
            placeholder="Start typing university name"
          />
        </div>
        <DateInput
          fullWidth
          inputVariant="outlined"
          format="MMM DD, YYYY"
          placeholder="Due date"
          value={due_date}
          onChange={this.onDateChange}
        />
        <Box textAlign="center" marginTop={3}>
          <Button
            size="large"
            onClick={this.onAdd}
            variant="contained"
            color="primary"
            disabled={!selected}
            loading={this.state.loading}
          >
            Add University
          </Button>
        </Box>
      </div>
    );
  }
}

export default withStyles(styles)(AddSchool);
